<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-mark`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 2h32a2 2 0 012 2v40.628a2 2 0 01-2.959 1.755L24.959 38.69a2 2 0 00-1.918 0L8.959 46.383A2 2 0 016 44.628V4a2 2 0 012-2zm2 4v35.256l11.123-6.077a6 6 0 015.754 0L38 41.256V6H10z"/></svg>
</template>
<script>

export default {
  name: 'IconMark',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
